import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';

@Injectable()
export class UsuariosService {

  usuarios: FirebaseListObservable<any[]>;

  constructor(private afDB: AngularFireDatabase) {
    this.usuarios = afDB.list('/ubicacion');
  }

  datos_user(){
    let promesa = new Promise((resolve, reject)=>{
      return this.afDB.list('/ubicacion');
    });
  }

  ubicacion_users( user:any ){
    return this.afDB.list('/ubicacion/'+user);
    /*
    return this.afDB.list('/ubicacion', {
      query:{
        orderByKey:'$key',
        equalTo:'pizanho18'
      }
    });
    */
  }

  valida_datos( user:string ){
      return this.afDB.object('/users/' + user);
  }
  valida_cuenta(cuenta:any){
    return this.afDB.object('/cuentas/' + cuenta);
  }

  valida_datos_list( user:string ){
      return this.afDB.list('/users/' + user);
  }

  guarda_service( id:any, datos:any ){
    return this.afDB.object('/servicios/' + id + '/' + datos);
  }

  cosnulta_serv(){
    return this.afDB.list('/servicios');
  }

  consulta_servicios( cuenta:any ){
    return this.afDB.list('/servicios/' + cuenta);
  }

  consulta_service_id( id:any ){
    return this.afDB.object('/servicios/' + id);
  }

  consulta_users(){
    return this.afDB.list('/users/');
  }

  update_user(user:any, dato:any){
    const usuario = this.afDB.object("/users/"+user);
    return usuario.update({key:dato});
  }

  delete_ser( id:string ){
    const serv = this.afDB.list("/servicios/"+id);
    return serv.remove();
  }

  seguimiento( user:any ){
    const seg = this.afDB.object("/ubicacion/"+user);
    return seg;
  }

  datos_panel( user:any ){
    const seg = this.afDB.object("/ubicacion/"+user);
    return seg;
  }

  sidebar(){
    const sidebar = this.afDB.list('/ubicacion');
    return sidebar;
  }

  marca_is_open(user:any, status:boolean){
    const marca = this.afDB.object("/ubicacion/"+user);
    return marca.update({ isOpen:status});
  }

  status_notifi(nodo:any){
    const notifi = this.afDB.object("/servicios/"+nodo);
    return notifi.update({ status_notify:1 });
  }

  status_notifi_user(nodo:any, user:any){
    const notifi = this.afDB.object("/servicios/"+user+"/"+nodo);
    return notifi.update({ status_notify:1 });
  }

  status_notifi_event(nodo:any){
    const notifi = this.afDB.object("/notificaciones/"+nodo);
    return notifi.update({ status_notifi:1 });
  }

  consult_notificaciones(){
    const notifi = this.afDB.list("/notificaciones");
    return notifi;
  }

  consult_notify_cuenta( cuenta:any ){
    const notify = this.afDB.list("/eventos/"+cuenta);
    return notify;
  }

  consult_registro(user:any){
    const registro =  this.afDB.list("/registro/"+user);
    return registro;
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/servicios/usuarios.service.ts